import React from 'react';
import RequireRootRole from './components/RequireRootRole';
import PromptPipelineSettings from './components/PromptPipelineSettings';
import DashboardConfigService from '../../../../services/DashboardConfigService';

// Mismas reglas que analysis_config.SCOPES["DASHBOARD"] (backend).
export const DASHBOARD_DESCRIPTOR = {
  title: 'Generación de tableros',
  description: 'Prompts, modelos y límites del modo "Dashboard" del chat: la IA diseña un tablero de 4 a 8 mosaicos sobre las conexiones del workspace y cada mosaico se calcula con su propia consulta. Los cambios aplican en el siguiente tablero, sin desplegar nada.',
  service: DashboardConfigService,
  stages: [
    {
      key: 'designer',
      label: '1. Diseñador',
      description: 'Convierte la petición en un tablero: elige los mosaicos (indicadores, tendencia, desglose, top N, participación, tabla), la fuente de cada uno y su consulta en el dialecto de esa fuente.',
      placeholders: [
        ['<<question>>', 'petición del usuario'],
        ['<<schema_context>>', 'fuentes del workspace: motor, conexión, tablas y columnas'],
        ['<<conversation_context>>', 'turnos previos de la conversación (opcional)'],
        ['<<max_tiles>>', 'máximo de mosaicos']
      ],
      required: ['<<question>>', '<<schema_context>>', '<<max_tiles>>', '<dashboard>', '</dashboard>']
    },
    {
      key: 'repair',
      label: '2. Reparación',
      description: 'Solo si un mosaico falla al ejecutarse (y la opción está activa): recibe sus consultas con el error y devuelve las corregidas. Una llamada al modelo por tablero como máximo.',
      placeholders: [
        ['<<schema_context>>', 'fuentes del workspace'],
        ['<<tiles>>', 'mosaicos fallidos con su consulta y el error']
      ],
      required: ['<<schema_context>>', '<<tiles>>', '<repaired>', '</repaired>']
    }
  ],
  limits: [
    { key: 'max_tiles', label: 'Mosaicos máximos', min: 1, max: 12 },
    { key: 'max_rows_per_tile', label: 'Filas máximas por mosaico', min: 1, max: 5000 },
    { key: 'statement_timeout_seconds', label: 'Duración por consulta (s)', min: 5, max: 120 },
    { key: 'max_scanned_mb', label: 'MB escaneados en Athena', min: 1, max: 102400 },
    { key: 'max_concurrent_per_connection', label: 'Consultas simultáneas por conexión', min: 1, max: 4 },
    { key: 'time_budget_seconds', label: 'Tiempo máximo del tablero (s)', min: 60, max: 840 }
  ],
  options: [
    { key: 'allow_repair', label: 'Reparar automáticamente los mosaicos que fallen (una llamada extra al modelo)' }
  ],
  limitsTitle: 'Límites del tablero',
  limitsSubtitle: 'Se aplican en el código y en cada motor de base de datos. Un mosaico que excede las filas se marca como incompleto; uno que excede el tiempo se cancela en el motor y muestra el motivo, sin tumbar el resto del tablero.',
  enabledLabel: 'Modo Dashboard habilitado',
  disabledLabel: 'Modo Dashboard deshabilitado para todos los usuarios',
  savedMessage: 'Configuración guardada. Aplica en el siguiente tablero.'
};

const DashboardSettings = () => (
  <RequireRootRole title="Generación de tableros">
    <PromptPipelineSettings descriptor={DASHBOARD_DESCRIPTOR} />
  </RequireRootRole>
);

export default DashboardSettings;
